(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sht-product-status-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.querySelector('[data-sht-status-config]');
  const template = config?.querySelector('[data-sht-status-template]');
  if (!config || !template) return;
  let ownedIds = new Set(), ownedHandles = new Set(), wishIds = new Set(), wishHandles = new Set();
  let controller, revision = 0, repaintPending = false;
  const productHandle = (href) => {
    try {
      const url = new URL(href, location.origin);
      if (url.origin !== location.origin) return '';
      return url.pathname.match(/\/products\/([a-z0-9-]+)(?:\/|$)/)?.[1] || '';
    } catch { return ''; }
  };
  function paint() {
    repaintPending = false;
    document.querySelectorAll('.shtff-card').forEach(card => {
      const heading = card.querySelector('.shtff-product-title');
      if (!heading || card.querySelector('.sht-product-status')) return;
      const handle = productHandle(card.getAttribute('href'));
      if (!handle) return;
      const labels = template.content.firstElementChild.cloneNode(true);
      labels.dataset.shtStatusProduct = '';
      labels.dataset.shtStatusHandle = handle;
      heading.after(labels);
    });
    document.querySelectorAll('[data-sht-status-product]').forEach(labels => {
      const id = labels.dataset.shtStatusProduct, handle = labels.dataset.shtStatusHandle;
      const owned = ownedIds.has(id) || ownedHandles.has(handle);
      const wished = wishIds.has(id) || wishHandles.has(handle);
      labels.querySelector('[data-sht-status-owned]').hidden = !owned;
      labels.querySelector('[data-sht-status-wishlist]').hidden = !wished;
      labels.hidden = !owned && !wished;
    });
  }
  function schedulePaint() {
    if (!repaintPending) { repaintPending = true; requestAnimationFrame(paint); }
  }
  function clear() {
    ownedIds.clear(); ownedHandles.clear(); wishIds.clear(); wishHandles.clear();
    paint();
  }
  function stop() { revision++; controller?.abort(); controller = undefined; clear(); }
  function addGroup(group, ids, handles) {
    if (!group || !Array.isArray(group.ids) || !Array.isArray(group.handles)) throw new Error('Invalid product statuses');
    group.ids.forEach(id => { if (/^[1-9]\d{0,19}$/.test(String(id))) ids.add(String(id)); });
    group.handles.forEach(handle => { if (typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)) handles.add(handle); });
  }
  async function refresh() {
    stop();
    if (document.hidden) return;
    const ownRevision = revision;
    const active = controller = new AbortController();
    let customer = null, totalPages = 1;
    try {
      for (let page = 1; page <= totalPages; page++) {
        const endpoint = new URL(config.dataset.root || '/', location.origin);
        endpoint.searchParams.set('section_id', 'sht-product-status-data');
        endpoint.searchParams.set('page', String(page));
        endpoint.searchParams.set('_sht_status', String(Date.now()));
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) endpoint.searchParams.set('preview_theme_id', preview);
        const timer = setTimeout(() => active.abort(), 15000);
        let data;
        try {
          const response = await fetch(endpoint, {credentials:'same-origin', cache:'no-store', signal:active.signal, headers:{Accept:'text/html'}});
          if (!response.ok) throw new Error('Status unavailable');
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const payload = html.querySelector('[data-sht-status-data]');
          if (!payload) throw new Error('Status unavailable');
          data = JSON.parse(payload.textContent);
        } finally { clearTimeout(timer); }
        if (ownRevision !== revision) return;
        if (page === 1 && data.customer === null) return;
        if (typeof data.customer !== 'string' || !/^\d+$/.test(data.customer) || (page > 1 && customer !== data.customer)) throw new Error('Account changed');
        customer = data.customer;
        if (data.page !== page || !Number.isInteger(data.pages) || data.pages < page || data.pages > 1250 || !Array.isArray(data.owned)) throw new Error('Invalid pagination');
        totalPages = data.pages;
        if (page === 1) addGroup(data.wishlist, wishIds, wishHandles);
        data.owned.forEach(group => addGroup(group, ownedIds, ownedHandles));
        paint();
      }
    } catch {
      if (ownRevision === revision) clear();
    } finally { if (ownRevision === revision) controller = undefined; }
  }
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.closest?.('.sht-product-status')))) schedulePaint();
  }).observe(document.body, {childList:true, subtree:true});
  document.addEventListener('visibilitychange', () => document.hidden ? stop() : refresh());
  window.addEventListener('pagehide', stop);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('focus', () => { if (!controller) refresh(); });
  document.addEventListener('shopify:section:load', schedulePaint);
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
